import { Suspense } from 'react';
import { Loader } from '@mews-commander/ui';
import { Divider, Stack } from '@optimus-web/core';
import { ReservationInfoHeader, ReservationInfoHeaderProps } from '../../common';
import { ProductsList, ProductsListProps } from './productsList';

export type ProductsContentProps = ProductsListProps & Partial<ReservationInfoHeaderProps>;

export const ProductsContent = ({ resourceId, ownerAccount, startDate, endDate, ...props }: ProductsContentProps) => (
    <Stack vertical spacing="200">
        {resourceId && ownerAccount && startDate && endDate ? (
            <ReservationInfoHeader
                resourceId={resourceId}
                ownerAccount={ownerAccount}
                startDate={startDate}
                endDate={endDate}
            />
        ) : null}
        <Suspense fallback={<Loader />}>
            <Divider />
            <ProductsList {...props} />
        </Suspense>
    </Stack>
);
